import * as css from "css";

const kebabToCamel = str => {
    return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
};

export const parseCSS = customCSS => {
    const parsedCSS = css.parse(`.custom-css { ${customCSS} }`);
    const cssObject = {};
    if (parsedCSS?.stylesheet?.rules) {
        if (parsedCSS.stylesheet.rules.length > 0) {
            if (parsedCSS.stylesheet.rules[0].declarations) {
                const declarations = parsedCSS.stylesheet.rules[0].declarations;
                for (let i = 0; i < declarations.length; i++) {
                    if (declarations[i].property && declarations[i].value) {
                        cssObject[kebabToCamel(declarations[i].property)] = declarations[i].value;
                    }
                }
            }
        }
    }
    return cssObject;
};
